<template>
  <!-- content(s) -->
  <div>
    <section>
      <div class="titArea">
        <span class="txtL pointC4">
          <em v-if="userInfo">{{ userInfo.userName }}님</em>
          <em v-else>고객님</em>
          , 환영합니다.
          <br />
          지금 사용 가능한 혜택을 확인해보세요.
        </span>
      </div>
    </section>

    <section v-if="userInfo">
      <ul class="cuponState">
        <li>
          <a @click="$router.push({ name: 'benefitsCoupon', params: { downCoupon: false } })">
            <span class="item cupon">내가 받은 쿠폰</span>
            <p class="val">
              <em>{{ myBenefitSummary.downloadedCouponCount }}</em>
              개
            </p>
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'benefitsCoupon', params: { downCoupon: true } })">
            <span class="item download">다운 가능한 쿠폰</span>
            <p class="val">
              <em>{{ myBenefitSummary.downloadableCouponCount }}</em>
              개
            </p>
          </a>
        </li>
      </ul>

      <div v-if="userInfo" class="orderSum mybf">
        <ul class="infoList">
          <li>
            <a @click="$router.push('/benefits/myBenefits')">
              <span class="item">내가받은혜택</span>
              <span class="val">
                <span class="money">
                  총
                  <em>{{ myBenefitSummary.benefitAmounts | currency }}</em>
                  원
                </span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>

    <section class="full hr mg0">
      <ul class="pageLinkBox btNone bdNone">
        <li>
          <a @click="$router.push('/benefits/welmallBenefits')" class="ico benefit pointC4">웰몰의 혜택안내</a>
        </li>
      </ul>
    </section>

    <!-- 다운가능 쿠폰 -->
    <section v-if="downCouponList.length > 0" class="hr">
      <div class="btnArea mt20">
        <button type="button" class="btn_p m download" @click="confirmPop = true"><span>쿠폰 모두받기</span></button>
      </div>

      <ul class="myCuponWrap">
        <li v-for="(coupon, index) in downCouponList" :key="index">
          <div class="block">
            <!--<div class="info" :class="'color' + (index + 1)">-->
            <div class="info">
              <p class="tit" v-if="coupon.discountAmount > 0">
                <em>{{ coupon.discountAmount | currency }}</em>
                원 할인
              </p>
              <p class="tit" v-else>
                <em>{{ coupon.convTxt }}</em>
              </p>
              <p class="copy">{{ coupon.title }}</p>
              <p class="period">
                {{ coupon.startDate | dateFormatter('-') }} ~ {{ coupon.endDate | dateFormatter('-') }}
                <span>({{ coupon.restDate }}일 남음)</span>
              </p>
            </div>
            <div class="btnWrap">
              <button type="button" class="btn_g download" @click="confirmPop = true"><span>쿠폰받기</span></button>
              <button type="button" class="btn_s btnMore" @click="showDetail(index)">
                <span v-show="detail[index]">접기</span>
                <span v-show="!detail[index]">상세보기</span>
              </button>
            </div>
            <div class="desc" v-show="detail[index]">
              <ul class="txtList_dash">
                <li v-for="(conditionObj, index) in coupon.conditions" :key="index">{{ conditionObj.condition }}</li>
              </ul>
            </div>
            <a class="btnView" @click="detailPop(coupon.couponId)">적용상품보기</a>
          </div>
        </li>
      </ul>
    </section>

    <BenefitsEventDetailPop
      v-if="benefitsEventDetailPopFlag"
      :couponIndex="couponIndex"
      @close="benefitsEventDetailPopFlag = false"
    ></BenefitsEventDetailPop>

    <ConfirmPop v-if="confirmPop" @cancel="confirmPop = false" @confirm="login" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>

    <CommonBanner></CommonBanner>
  </div>
  <!-- content(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import CommonBanner from '@/components/banner/CommonBanner';
// import { isEmpty } from '@/common/common.function';
import { LOGIN_REQUIRE } from '@/store/message.type';
import ConfirmPop from '@/components/popup/ConfirmPop';
import BenefitsEventDetailPop from '@/components/popup/BenefitsEventDetailPop';
//import * as customjs from '@/../static/js/m.front.js';

export default {
  name: 'benefits',
  props: ['main'],
  components: { CommonBanner, ConfirmPop, BenefitsEventDetailPop },
  data: function() {
    return {
      headerTitle: '나만의혜택',
      userInfo: JwtService.getUserInfo(),
      myBenefitSummary: {
        downloadedCouponCount: 0,
        downloadableCouponCount: 0,
        benefitAmounts: 0,
      },
      downCouponList: [], // 다운가능 쿠폰
      benefitsEventDetailPopFlag: false,
      detail: [], // 쿠폰 내용 상세보기
      couponIndex: null, // 적용가능 상품용 쿠폰ID
      msg: LOGIN_REQUIRE,
      confirmPop: false,
    };
  },
  created() {
    if (JwtService.getToken()) {
      this.selectMyBenefitSummary();
    } else {
      ApiService.service('GET', '/user/nonmember/coupon/available')
        .then(({ data }) => {
          console.log(data);
          this.downCouponList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    }
  },
  methods: {
    selectMyBenefitSummary() {
      ApiService.service('GET', '/user/auth/mybenefit/summary')
        .then(({ data }) => {
          console.log(data);
          this.myBenefitSummary = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    login() {
      this.$router.push({ name: 'benefitsCoupon', params: { downCoupon: true } });
    },
    showDetail(index) {
      this.$set(this.detail, index, !this.detail[index]);
    },
    detailPop(couponId) {
      this.couponIndex = couponId;
      this.benefitsEventDetailPopFlag = true;
    },
  },
};
</script>
